"use client";

import { c as _c } from "react/compiler-runtime";
import { normalizeCartLineQuantity } from "../cart-line-utils";
import { type CatalogOfferAction, getCatalogPromotionDetails } from "../promotion-messaging";
import React, { useState } from "react";
import { FiCheckCircle, FiImage, FiPlus, FiTag } from "react-icons/fi";
import Button from "@/components/ui/button";
import QuantityStepper from "@/components/ui/quantity-stepper";
import { formatCurrency } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import type { ItemType } from "@/types/enums/item-type";
import type { ShopCartLine, ShopItem } from "@/types/shop";
interface PromotionQuickAddRowProps {
  action: CatalogOfferAction;
  itemType: ItemType;
  cartQuantity: number;
  onQuickAdd: (itemId: string, quantity: number) => void;
}
const PromotionQuickAddRow: React.FC<PromotionQuickAddRowProps> = t0 => {
  const $ = _c(36);
  const {
    action,
    itemType,
    cartQuantity,
    onQuickAdd
  } = t0;
  let t1;
  if ($[0] !== action.quantity || $[1] !== itemType) {
    t1 = () => normalizeCartLineQuantity(itemType, action.quantity);
    $[0] = action.quantity;
    $[1] = itemType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [quantity, setQuantity] = useState(t1);
  const [justMet, setJustMet] = useState(false);
  const requirementMet = cartQuantity >= action.quantity || justMet;
  let t2;
  if ($[3] !== action.itemId || $[4] !== action.quantity || $[5] !== cartQuantity || $[6] !== itemType || $[7] !== onQuickAdd || $[8] !== quantity) {
    t2 = () => {
      const normalizedQuantity = normalizeCartLineQuantity(itemType, quantity);
      onQuickAdd(action.itemId, normalizedQuantity);
      if (cartQuantity + normalizedQuantity >= action.quantity) {
        setJustMet(true);
      }
    };
    $[3] = action.itemId;
    $[4] = action.quantity;
    $[5] = cartQuantity;
    $[6] = itemType;
    $[7] = onQuickAdd;
    $[8] = quantity;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleQuickAdd = t2;
  const t3 = requirementMet ? "border-status-success-text/30 bg-status-success-bg" : "border-border bg-background";
  let t4;
  if ($[10] !== t3) {
    t4 = cx("flex flex-wrap items-center gap-3 rounded-xl border p-2 transition-colors duration-300", t3);
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== action.itemImage) {
    t5 = action.itemImage ? <img src={action.itemImage} alt="" loading="lazy" className="h-12 w-12 flex-none rounded-lg bg-muted object-cover" /> : <span className="flex h-12 w-12 flex-none items-center justify-center rounded-lg bg-muted text-foreground-muted"><FiImage aria-hidden={true} /><span className="sr-only">No item image</span></span>;
    $[12] = action.itemImage;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== action.itemName) {
    t6 = <p className="truncate text-body-emphasis text-foreground">{action.itemName}</p>;
    $[14] = action.itemName;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== action.itemDescription) {
    t7 = action.itemDescription && <p className="mt-0.5 line-clamp-2 text-caption leading-relaxed text-foreground-secondary">{action.itemDescription}</p>;
    $[16] = action.itemDescription;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== action.itemPrice) {
    t8 = formatCurrency(action.itemPrice);
    $[18] = action.itemPrice;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <p className="mt-1 text-caption font-semibold text-foreground">{t8} each</p>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t9) {
    t10 = <div className="min-w-32 flex-1">{t6}{t7}{t9}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== handleQuickAdd || $[27] !== itemType || $[28] !== quantity || $[29] !== requirementMet) {
    t11 = requirementMet ? <span role="status" className="flex animate-in items-center gap-2 whitespace-nowrap px-2 text-caption font-semibold text-status-success-text fade-in zoom-in-95 duration-300 motion-preset-confetti"><FiCheckCircle aria-hidden={true} />Requirement met</span> : <><QuantityStepper value={quantity} onChange={nextQuantity => {
        setQuantity(normalizeCartLineQuantity(itemType, nextQuantity));
        setJustMet(false);
      }} /><Button variant="secondary" onClick={handleQuickAdd} className="h-9 cursor-pointer gap-2 whitespace-nowrap px-3 text-caption"><FiPlus aria-hidden={true} /><span>Quick add</span></Button></>;
    $[26] = handleQuickAdd;
    $[27] = itemType;
    $[28] = quantity;
    $[29] = requirementMet;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t4 || $[34] !== t5) {
    t12 = <div className={t4}>{t5}{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t4;
    $[34] = t5;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};
interface ConditionalPromotionOffersProps {
  item: ShopItem;
  catalogItems: ShopItem[];
  cartLines: ShopCartLine[];
  onQuickAdd: (itemId: string, quantity: number) => void;
}
const ConditionalPromotionOffers: React.FC<ConditionalPromotionOffersProps> = t0 => {
  const $ = _c(24);
  const {
    item,
    catalogItems,
    cartLines,
    onQuickAdd
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== cartLines || $[1] !== catalogItems || $[2] !== item || $[3] !== onQuickAdd) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const offers = getCatalogPromotionDetails(item, catalogItems).conditional;
      if (offers.length === 0) {
        t4 = null;
        break bb0;
      }
      let t5;
      if ($[8] !== catalogItems) {
        t5 = new Map(catalogItems.map(_temp));
        $[8] = catalogItems;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      const itemTypeById = t5;
      let cartQuantityByItemId;
      if ($[10] !== cartLines) {
        cartQuantityByItemId = new Map();
        for (const line of cartLines) {
          if (!("itemId" in line)) {
            continue;
          }
          cartQuantityByItemId.set(line.itemId, (cartQuantityByItemId.get(line.itemId) ?? 0) + line.quantity);
        }
        $[10] = cartLines;
        $[11] = cartQuantityByItemId;
      } else {
        cartQuantityByItemId = $[11];
      }
      t2 = "mt-6 border-t border-border pt-5";
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <div className="flex items-center gap-2"><FiTag aria-hidden={true} className="h-4 w-4 text-primary" /><h3 className="text-body-emphasis text-foreground">Promotions</h3></div>;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      let t6;
      if ($[13] !== cartQuantityByItemId || $[14] !== item || $[15] !== itemTypeById || $[16] !== onQuickAdd) {
        t6 = offer => <li key={offer.offerId} className="py-3"><p className="text-body-emphasis text-foreground">{offer.benefit ?? offer.name}</p><p className="mt-0.5 text-caption font-medium text-foreground-secondary">{offer.name}</p>{offer.description && <p className="mt-1 text-caption leading-relaxed text-foreground-secondary">{offer.description}</p>}{offer.requirementGroups.length > 1 && <p className="mt-3 text-caption text-foreground-secondary">Complete one option in each group:</p>}<ul className="mt-2 space-y-2 text-caption text-primary">{offer.requirementGroups.map(_temp2)}</ul>{offer.relationshipSummary && <p className="mt-3 text-caption font-medium text-foreground">{offer.relationshipSummary}</p>}{offer.actions.length > 0 && <div className="mt-3 space-y-2">{offer.actions.map(action => <PromotionQuickAddRow key={action.itemId} action={action} itemType={itemTypeById.get(action.itemId) ?? item.type} cartQuantity={cartQuantityByItemId.get(action.itemId) ?? 0} onQuickAdd={onQuickAdd} />)}</div>}</li>;
        $[13] = cartQuantityByItemId;
        $[14] = item;
        $[15] = itemTypeById;
        $[16] = onQuickAdd;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      t1 = offers.map(t6);
    }
    $[0] = cartLines;
    $[1] = catalogItems;
    $[2] = item;
    $[3] = onQuickAdd;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[18] !== t1) {
    t5 = <ul>{t1}</ul>;
    $[18] = t1;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t5) {
    t6 = <section className={t2}>{t3}{t5}</section>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
export default ConditionalPromotionOffers;
function _temp(catalogItem) {
  return [catalogItem.id, catalogItem.type];
}
function _temp2(group, groupIndex) {
  return <li key={group.group}>{groupIndex > 0 && <span className="mb-1 block font-semibold text-foreground-secondary">and</span>}{group.alternatives.map((alternative, alternativeIndex) => <React.Fragment key={`${group.group}-${alternativeIndex}`}>{alternativeIndex > 0 && <span className="block pl-3 font-semibold text-foreground-secondary">or</span>}<span className="block">{alternative}</span></React.Fragment>)}</li>;
}